import classnames from 'classnames';
import React from 'react';
import { InputGroup, InputGroupAddon, InputGroupText, Input, Row } from 'reactstrap';
import { InlineTooltip } from '../tooltips';
import './styles.css';

const Label = ({
    error,
    className,
    children,
    ...props
}) => {
    return (
        <label className="label" {...props}>
            {children}
        </label>
    );
};

export const TextInputGroup = ({
    type,
    id,
    label,
    textTooltip,
    error,
    value,
    onChange,
    addonText,
    required,
    className,
    placeholder,
    ...props
}) => {


    const classes = classnames(
        // 'input-group',
        {
            'animated shake error': !!error,
        },
        className
    );


    let inline = '';

    if (textTooltip !== undefined) {
        inline =
            <InlineTooltip id={id} text={textTooltip} />
    }
    return (
        <div style={{ marginBottom: 10 }}>
            <Row>
                <div className="col-md-12"  >
                    <div className={classes}>
                        <Label htmlFor={id} error={error}>
                            {label}{required ? "* " : <span className='text-iotera-optional'>{' (Optional) '}</span>}
                            {inline}
                        </Label>
                    </div>
                </div>
                <div className="col-md-12"  >
                    <InputGroup className={classes} style={{ marginBottom: 0 }}>
                        <InputGroupAddon addonType="append" ><InputGroupText>{addonText}</InputGroupText></InputGroupAddon>
                        <Input
                            className="input-mask"
                            id={id}
                            type={type}
                            value={value}
                            placeholder={placeholder}
                            onChange={onChange}
                        />
                    </InputGroup>
                </div>
            </Row>
            <Row>
                <div className="col-md-12"  >
                    <div className={classes}>
                        <InputFeedback error={error} />
                    </div>
                </div>
            </Row>
        </div>
    );
};


const InputFeedback = ({ error }) =>
    error ?
        <div className="input-feedback" style={{ fontStyle: 'italic' }}>{error}</div> : null